type CounsellorNameProps = {
  firstName?: string | null;
  lastName?: string | null;
};

export const getCounsellorName = ({
  firstName,
  lastName,
}: CounsellorNameProps): string | null =>
  firstName && lastName
    ? `${firstName || ''} ${lastName || ''}`
    : firstName || lastName || null;

export const getCounsellorShortName = ({
  firstName,
  lastName,
}: CounsellorNameProps): string => {
  const firstLetterFirstName = (firstName || '').charAt(0);
  const firstLetterLastName = (lastName || '').charAt(0);
  const joinAble = [firstLetterFirstName, firstLetterLastName];
  return joinAble.join('').toUpperCase();
};
